import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '../components/LazyRoute'
import { TablePageLoader } from '@/components/ui/page-loader'

export const Route = createFileRoute('/_protected/circuit-breakers')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/pages/CircuitBreakers')}
      fallback={<TablePageLoader />}
    />
  ),
})
